import styled from './index.module.css';
import { Alert } from '@vivaahealth/design-system';
import * as api from '../../api';
import { useState } from 'react';
import { Button } from '../../components/Button';

interface Props {
  buttonTitle: string;
  url: string;
  encounterId?: string;
}

export const ButtonLink = ({ buttonTitle, url, encounterId }: Props) => {
  const [error, setErrors] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleOnClick = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (url === 'https://web.musc.edu/inourdnasc') {
      setIsLoading(true);
      await openWithConsentLink();
      setIsLoading(false);
    } else {
      window.open(url, '_blank');
    }
  };

  const openWithConsentLink = async () => {
    if (!encounterId) {
      setErrors('An error has occurred. Please try again at a later time');
      return;
    }

    try {
      const consentLink: string = await api.client.Previsit.generateConsentLink(
        {
          encounterId,
        },
      );
      window.open(consentLink, '_blank');
    } catch (errors) {
      setErrors('An error has occurred. Please try again at a later time');
    }
  };

  return (
    <>
      <div className={styled.AlertWrapper}>
        {error && <Alert variant="danger">{error}</Alert>}
      </div>
      <Button disabled={isLoading} onClick={(e) => handleOnClick(e)}>
        {isLoading ? 'Loading...' : buttonTitle}
      </Button>
    </>
  );
};
